import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["disabled", "placeholder", "onChange", "value"];

/*
 * @Author: your name
 * @Date: 2021-01-07 13:33:56
 * @LastEditTime: 2022-01-12 16:55:35
 * @LastEditors: wangshengqiang
 * @Description: 仅给职业组件使用
 * @FilePath: /za-dplatform-product-life/Users/zhongan/project/za-dplatform-main/za-dplatform-h5/src/components/RowCascade/index.js
 */
import React, { useState } from 'react';
import { StackPicker } from 'zarm';
import { getValuePath } from '@U/tool';
import { FormItem } from '@/baseComponents';
import { OCCUPATION_CATEGORY_MAP } from '@/constants/index.js';
import { Value } from '../common';
import './index.less';

const mapOccType = key => {
  return OCCUPATION_CATEGORY_MAP[key];
};

let scrollT = 0;

const fixScroll = flag => {
  if (flag) {
    scrollT = document.body.scrollTop;
    document.body.className = `fix-body-scroll ${document.body.className}`;
  } else {
    document.body.className = `${document.body.className.replace(/fix-body-scroll/g, '')}`;
    document.body.scrollTop = scrollT;
  }
};

const renderItem = item => {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "za-tol",
    style: {
      flex: 1
    }
  }, item.name), /*#__PURE__*/React.createElement("span", {
    style: {
      backgroundColor: '#fff',
      width: '52px',
      textAlign: 'center',
      color: '#909090'
    }
  }, mapOccType(item.occupationCategory)));
};

const displayRender = selected => {
  return selected.map(item => item.name);
};

const Cascade = props => {
  var _valuePath;

  const [visible, setVisible] = useState(false);

  const {
    disabled,
    placeholder,
    onChange,
    value
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  fixScroll(visible); // const _value = _.cloneDeep(rest.value);
  // const lastCode = _value && _value.length > 0 ? _value.pop() : '';

  const lastCode = value;
  const valuePath = getValuePath(lastCode, rest.dataSource, 'code');
  const text = Array.isArray(valuePath) ? (_valuePath = valuePath[valuePath.length - 1]) === null || _valuePath === void 0 ? void 0 : _valuePath.name : '';
  const codes = valuePath ? valuePath.map(i => i.code) : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Value, {
    disabled: disabled,
    onClick: () => setVisible(true),
    value: text,
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement(StackPicker, _extends({
    maskClosable: true
  }, rest, {
    value: codes,
    visible: visible,
    onOk: v => {
      let str = '';

      if (Array.isArray(v) && v.length > 0) {
        str = v[v.length - 1];
      }

      onChange(str);
      setVisible(false);
    },
    onCancel: () => setVisible(false)
  })));
};

export default function RowCascade(props) {
  const {
    label,
    attrs,
    remark = {},
    formKey,
    dataSource,
    isRequired,
    disabled,
    initialValue,
    isPremiumFactor,
    isBenefitFactor,
    cols = 1
  } = props;
  const {
    display = {}
  } = attrs || {};
  const {
    placeholder
  } = display;

  let _initialValue = display.hasDefaultValue && display.defaultValue ? JSON.parse(display.defaultValue) : undefined;

  if (initialValue) {
    _initialValue = initialValue;
  }

  const formItemProps = {
    name: formKey,
    remark,
    label,
    fieldOption: {
      rules: [{
        required: isRequired,
        message: '请选择'
      }],
      isPremiumFactor,
      isBenefitFactor,
      initialValue: _initialValue
    }
  };
  const cascadeProps = {
    cols,
    disabled,
    dataSource,
    title: label,
    placeholder,
    displayRender,
    displayMember: 'name',
    valueMember: 'code',
    itemRender: item => item.occupationCategory ? renderItem(item) : item.name
  };
  return /*#__PURE__*/React.createElement(FormItem, _extends({}, formItemProps, {
    className: "c-row-cascade"
  }), /*#__PURE__*/React.createElement(Cascade, cascadeProps));
}